import { assign } from 'lodash';

export default ($selector, options = {}) => {
  let $el = $selector;

  if (!$el) {
    throw new Error('Selector is empty');
  }

  if (!($el instanceof $)) {
    $el = $($el);
  }

  if (!$el.length) {
    return false;
  }

  return require.ensure(
    [],
    require => {
      require('select2/dist/js/select2.full');
      require('select2/dist/js/i18n/ru');
      require('select2/dist/css/select2.css');

      const settings = {
        minimumResultsForSearch: 5,
      };

      $el.each((index, $item) => {
        const $current = $($item);

        const multiple = $current.is('[multiple]');
        const placeholder = multiple
          ? 'Выберите несколько вариантов'
          : 'Выберите вариант';
        const opts = assign(
          {},
          settings,
          {
            closeOnSelect: !multiple,
            placeholder: options.placeholder || placeholder,
          },
          options
        );

        $current.select2(opts);
      });

      return $el;
    },
    'select'
  );
};



// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/modules/select2.js